import {
   FormControl,
   Textarea,
   FormLabel,
   FormErrorMessage,
   Flex,
   Text,
   useColorModeValue,
   forwardRef,
} from '@chakra-ui/react';
import React, { useState } from 'react';

const TextareaField = forwardRef(
   (
      {
         name,
         control,
         register,
         label,
         type = 'text',
         isDisabled = false,
         required = false,
         value,
         onChange,
         errors = {},
         errorName,
         ...props
      },
      ref,
   ) => {
      const [isFocused, setIsFocused] = useState(false);
      const textColor = useColorModeValue('gray.800', 'white');
      const bgColor = useColorModeValue('white', '#2d3748');
      const isFloating = !!(value !== '' && value !== null && value !== undefined);
      return (
         <FormControl position="relative" isInvalid={errors[errorName]}>
            <Textarea
               ref={ref}
               id={name}
               value={value}
               onChange={onChange}
               name={name}
               type={type}
               isDisabled={isDisabled}
               onFocus={() => setIsFocused(true)}
               onBlur={() => setIsFocused(false)}
               borderRadius="md"
               borderColor="gray.300"
               paddingTop={1}
               paddingBottom="0.25rem"
               {...props}
            />
            <FormLabel
               htmlFor={name}
               position="absolute"
               top={isFocused || isFloating ? '-8px' : '5px'}
               left="0.75rem"
               fontSize={isFocused || isFloating ? 'xs' : 'md'}
               color={textColor}
               pointerEvents="none"
               backgroundColor={bgColor}
               bg={bgColor}
               px="1"
               zIndex={1}
               transition="all 0.2s ease-in-out">
               <Flex>
                  {label}
                  {required ? (
                     <Text color="red.500" ml={1}>
                        *
                     </Text>
                  ) : null}
               </Flex>
            </FormLabel>
            {errors[errorName] ? <FormErrorMessage>{errors[errorName]}</FormErrorMessage> : null}
         </FormControl>
      );
   },
);

export default TextareaField;
